/* ==========================================================================
   OASIS PREMIUM RECOVERY — Custom JS Bundle
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  /* ── 1. Brochure request modal logic ── */
  (function () {
    var urlParams    = new URLSearchParams(window.location.search);
    var modal        = document.getElementById('oasis-modal');
    var formContent  = document.getElementById('modal-content-form');
    var successContent = document.getElementById('modal-content-success');
    var brochureForm = document.getElementById('brochure-form');
    var validateBtn  = document.getElementById('btn-validate-trigger');
    var errorDiv     = document.getElementById('oasis-error-message');
    var openBtns     = document.querySelectorAll('a[href="#start-journey"]');

    var msgOpen = false;
    var toggleBtn   = document.getElementById('oasis-msg-toggle-btn');
    var toggleIcon  = document.getElementById('oasis-msg-toggle-icon');
    var toggleLabel = document.getElementById('oasis-msg-toggle-label');
    var msgArea     = document.getElementById('oasis-msg-area');

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        msgOpen = !msgOpen;
        msgArea.style.display     = msgOpen ? 'block' : 'none';
        toggleIcon.style.transform = msgOpen ? 'rotate(90deg)' : 'rotate(0deg)';
        toggleLabel.textContent   = msgOpen ? 'Remove message' : 'Add a message (optional)';
        toggleBtn.setAttribute('aria-expanded', String(msgOpen));
      });
    }

    function resetFieldBorders() {
      ['modal-email', 'modal-phone'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.style.borderColor = '#e1e1e1';
      });
    }

    function showOasisModal(state) {
      if (!modal) return;
      modal.style.display = 'flex';
      if (errorDiv) errorDiv.style.setProperty('display', 'none', 'important');
      resetFieldBorders();

      // The current #oasis-modal is a contact panel without form/success panes.
      if (!formContent || !successContent) return;

      if (state === 'success') {
        formContent.style.display    = 'none';
        successContent.style.display = 'block';
      } else {
        formContent.style.display    = 'block';
        successContent.style.display = 'none';
      }
    }

    if (urlParams.has('customer_posted')) showOasisModal('success');

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!modal) return; // no modal on this page — let link behave normally
        e.preventDefault();
        var alreadySent = sessionStorage.getItem('oasis_request_sent') === 'true';
        showOasisModal(alreadySent ? 'success' : 'form');
      });
    });

    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) modal.style.display = 'none';
      });
    }

    if (validateBtn && brochureForm) {
      validateBtn.addEventListener('click', function () {
        var emailVal = document.getElementById('modal-email').value.trim();
        var phoneVal = document.getElementById('modal-phone').value.trim();

        var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        var phoneRegex = /^\+?[\d\s\-]{9,18}$/;

        var msg = '';
        if (!emailRegex.test(emailVal)) {
          msg = 'Please enter a valid email (e.g. name@domain.com)';
        } else if (!phoneRegex.test(phoneVal)) {
          msg = 'Please enter a valid phone number (min. 9 digits)';
        }

        if (msg !== '') {
          errorDiv.textContent = msg;
          errorDiv.style.setProperty('display', 'block', 'important');
          document.getElementById('modal-email').style.borderColor = !emailRegex.test(emailVal) ? '#d9534f' : '#e1e1e1';
          document.getElementById('modal-phone').style.borderColor = !phoneRegex.test(phoneVal) ? '#d9534f' : '#e1e1e1';
          return;
        }

        var params   = new URLSearchParams(window.location.search);
        var msgVal   = (document.getElementById('modal-message') || {}).value || '';
        var noteData = JSON.stringify({
          request_type: 'brochure_request',
          phone:        phoneVal,
          message:      msgVal || '',
          landing:      window.location.pathname,
          referrer:     document.referrer || 'direct',
          utm_source:   params.get('utm_source')   || '',
          utm_medium:   params.get('utm_medium')   || '',
          utm_campaign: params.get('utm_campaign') || '',
          submitted_at: new Date().toISOString()
        });

        var noteInput = document.getElementById('modal-lead-note');
        if (noteInput) noteInput.value = noteData;

        sessionStorage.setItem('oasis_request_sent', 'true');
        brochureForm.submit();
      });
    }
  })();

  /* ── 2. Eyebrow text injector ── */
  (function () {
    var _eyebrowTimeout = setTimeout(function () { observer.disconnect(); }, 5000);
    var observer = new MutationObserver(function (mutations, obs) {
      var targetHeading = document.querySelector('[class*="ai-hero-video__heading-"]');
      if (targetHeading && !document.querySelector('.oasis-injected-eyebrow')) {
        clearTimeout(_eyebrowTimeout);
        var eyebrow = document.createElement('p');
        eyebrow.className = 'oasis-injected-eyebrow';
        eyebrow.innerText = 'RECLAIM YOUR LIFE IN PRIVATE, SAFE SANCTUARY';
        eyebrow.style.cssText = [
          'display: block',
          'font-size: clamp(12px, 1.2vw, 14px)',
          'letter-spacing: 0.3em',
          'text-transform: uppercase',
          'color: #FFFFFF',
          'opacity: 0.8',
          'margin-bottom: 15px',
          'font-weight: 500',
          'line-height: 1.2',
          'text-align: inherit'
        ].join(' !important;') + ' !important';
        targetHeading.parentNode.insertBefore(eyebrow, targetHeading);
        obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();

  /* ── 3. Auto alt text generator ── */
  (function () {
    var brandName = 'Oasis Premium Recovery';
    var EXCLUDE_SMALL = { width: 60, height: 80 };

    function generateAltText(img) {
      if (!img || img.dataset.altAdded) return;
      if (img.alt && img.alt.trim() !== '') return; // never overwrite intentional alt text

      var filename = (img.src || img.dataset.src || '')
        .split('/').pop().split('.')[0]
        .replace(/screenshot|screen/gi, '')
        .replace(/\d+/g, '')
        .replace(/[-_]/g, ' ')
        .trim();

      var detail = filename
        ? filename.charAt(0).toUpperCase() + filename.slice(1)
        : 'Image';
      detail = detail.replace(/\b(img|image|foto|pic|wp|banner|bg|icon)\b/gi, '').trim();

      var pageContext = document.title.split(/[\|\-]/)[0].trim();
      if (!pageContext || pageContext.length < 3) {
        var h1 = document.querySelector('h1, .page-title');
        pageContext = h1 ? h1.textContent.trim().substring(0, 30) : 'Oasis Page';
      }

      var altText = (detail !== 'Image' && detail.length > 2)
        ? brandName + ' - ' + detail + ' - ' + pageContext
        : brandName + ' - ' + pageContext;

      // Defer dimension check until image has loaded — naturalWidth is 0 before load
      function applyAlt() {
        // Fix: explicit parentheses — && has higher precedence than ||
        if ((img.naturalWidth < EXCLUDE_SMALL.width || img.width < EXCLUDE_SMALL.width) && img.height < EXCLUDE_SMALL.height) {
          altText = '';
        }
        img.alt = altText;
        img.dataset.altAdded = 'true';
      }

      if (img.complete && img.naturalWidth > 0) {
        applyAlt();
      } else {
        img.addEventListener('load',  applyAlt, { once: true });
        img.addEventListener('error', applyAlt, { once: true });
      }
    }

    document.querySelectorAll('img').forEach(generateAltText);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'IMG') generateAltText(node);
          else node.querySelectorAll('img').forEach(generateAltText);
        });
        if (mutation.type === 'attributes' && mutation.target.tagName === 'IMG') {
          generateAltText(mutation.target);
        }
      });
    });

    // attributes observer removed — fires on every DOM change, too expensive
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();
});